export enum CrashMatchSortDirection {
    Ascending = "Ascending",
    Descending = "Descending"
}
